import { httpIS4, httpMasterData } from './http';

const controller = '/master-data/role-users';

export const getUserLogin = async () => await httpMasterData.get(`${controller}/get-full-access-app/2`);

export const changePassword = async (rq) => await httpIS4.post(`/api/Users/ChangePassword`, rq);
